import { SvgIcon } from '@mui/material'
import React from 'react'

function LockSvgIcon() {
  return (
    <SvgIcon sx={{ fontSize: 34, textAlign: 'center' }} viewBox={'0 0 23 32'}>
      <path
        d="M11.5 0C6.72202 0 2.875 3.89264 2.875 8.72727V12.6847C1.0904 14.7349 0 17.4171 0 20.3636C0 26.7898 5.14912 32 11.5 32C17.8509 32 23 26.7898 23 20.3636C23 17.4171 21.9096 14.7349 20.125 12.6847V8.72727C20.125 3.89264 16.278 0 11.5 0ZM11.5 2.90909C14.772 2.90909 17.25 5.41645 17.25 8.72727V10.2983C15.5568 9.30543 13.5976 8.72727 11.5 8.72727C9.40236 8.72727 7.4432 9.30543 5.75 10.2983V8.72727C5.75 5.41645 8.22798 2.90909 11.5 2.90909ZM11.5 16C13.0813 16 14.375 17.3091 14.375 18.9091C14.375 19.9782 13.7914 20.9058 12.9375 21.4119V26.1818H10.0625V21.4119C9.20862 20.9058 8.625 19.9782 8.625 18.9091C8.625 17.3091 9.91875 16 11.5 16Z"
        fill="#352E73"
      />
    </SvgIcon>
  )
}

export default LockSvgIcon
